"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTour = function SvgTour(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.779 5.125c2.154 0 3.997.826 4.588 1.947.21.396-.162.776-.61.776H14.51a.321.321 0 0 0-.31.4c1.062 4.047 1.145 7.38.932 9.788a.545.545 0 0 0 .472.587c2.842.37 5.113 1.234 6.16 2.334.483.511.162 1.411-.507 1.411H3.81c-.67 0-.989-.9-.507-1.41 1.053-1.11 3.35-1.981 6.225-2.343.425-.054.79-.34.913-.75a30.82 30.82 0 0 0 1.31-8.644v-.108c.007-.257-.32-.38-.488-.187-1.97 2.275-4.272 4.326-6.423 6.432-.32.313-.844.31-1.022-.099-.68-1.56.01-4.256 2.258-5.921.373-.277 1.246-.842 1.91-1.265.232-.148.124-.51-.153-.502-1.305.039-3.603.108-5.104.147-.621.015-.968-.617-.542-1.072.925-.985 2.608-2.277 5.09-2.277 1.04 0 2.019.248 2.903.738.176.097.417-.09.372-.286-.28-1.23.022-2.473 1.49-2.66.164-.02.297.126.276.293a79.48 79.48 0 0 0-.227 2.316.22.22 0 0 0 .42.112c.379-.684.838-1.553 1.286-2.016C15.187 1.426 16.9.755 18.03 1.08c.428.124.437.653.122.968l-2.699 2.689a.272.272 0 0 0 .214.464c.448-.036.963-.077 1.11-.077h.002Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTour);
var _default = exports["default"] = Memo;